var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22h6V8q0-1.25-.85-2.125T24 5q-1.25 0-2.125.85T21 8ZM9 31h30v-6H9ZM5.8 43h6.7v-4.5q0-.65.425-1.075Q13.35 37 14 37q.65 0 1.075.425.425.425.425 1.075V43h7v-4.5q0-.65.425-1.075Q23.35 37 24 37q.65 0 1.075.425.425.425.425 1.075V43h7v-4.5q0-.65.425-1.075Q33.35 37 34 37q.65 0 1.075.425.425.425.425 1.075V43h6.7l-2.5-10H8.3L5.8 43Zm35.1 3H7.1q-1.95 0-3.15-1.55T3.25 41L6 30v-4q0-1.65 1.175-2.825Q8.35 22 10 22h8V8q0-2.5 1.75-4.25T24 2q2.5 0 4.25 1.75T30 8v14h8q1.65 0 2.825 1.175Q42 24.35 42 26v4l2.75 11q.5 1.9-.7 3.45Q42.85 46 40.9 46ZM39 25H9h30Zm-12-3h-6 6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.caa3f581ff984d2af1d8b4f0c2367d2c.svg";
export { ForwardRef as ReactComponent };